export const TEXT_FIELD_VIEW_OMIT_PROPS = ['hasError', 'errorText'];
